/* eslint-disable jsx-a11y/alt-text */
import {
  Box,
  Button,
  Typography,
  FormControl,
  FormHelperText,
  OutlinedInput,
  useMediaQuery,
  Link,
  IconButton,
  InputAdornment,
  Grid,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import cover from "./covers-2.jpg";
import React, { useEffect, useMemo, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useAuth } from "../../contexts/authContext";
// import { ReactComponent as LoginImage } from "../../assets/images/LoginImage.svg";
import { VisibilityOff, Visibility } from "@mui/icons-material";
import { Link as RouterLink } from "react-router-dom";
import ThemeDefaultComponent from "../../components/ThemeDefaultComponent/ThemeDefaultComponent";
import LoadingOverlay from "../../components/LoadingOverlay/LoadingOverlay";

interface ILoginInputs {
  email: string;
  password: string;
}

const Schema = yup
  .object({
    email: yup
      .string()
      // .email("Format email salah")
      .required("Kolom wajib diisi"),
    password: yup.string().required("Kolom wajib diisi"),
  })
  .required();

const LoginPage = () => {
  const theme = useTheme();
  const isTabletScreen = useMediaQuery(theme.breakpoints.down("md"));
  const isLaptopScreen = useMediaQuery(theme.breakpoints.up("md"));
  const isDesktopScreen = useMediaQuery(theme.breakpoints.up("xl"));
  const { login, isLoading } = useAuth();
  const [showPassword, setShowPassword] = useState(false);
  const [saveEmail, setSaveEmail] = useState(false);
  const [initEmail, setInitEmail] = useState<any>();

  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const queryEmail = urlParams.get("email");

  const handleClickShowPassword = () => {
    setShowPassword((prev) => !prev);
  };

  const initialValues = useMemo(
    () => ({
      email: initEmail ?? "",
      password: "",
    }),
    [initEmail],
  );

  const {
    handleSubmit,
    control,
    watch,
    reset,
    formState: { errors },
  } = useForm<ILoginInputs>({
    resolver: yupResolver(Schema),
    defaultValues: initialValues,
  });

  const watchEmail = watch("email");

  useEffect(() => {
    if (localStorage.getItem("email")) {
      setSaveEmail(true);
    } else {
      setSaveEmail(false);
    }
  }, []);

  useEffect(() => {
    if (queryEmail) {
      reset({ email: queryEmail ?? "", password: "" });
    } else if (localStorage.getItem("email")) {
      reset({ email: localStorage.getItem("email") ?? "", password: "" });
    } else {
      setInitEmail("");
    }
  }, [queryEmail, reset]);

  const onSubmit = (data: ILoginInputs) => {
    login(data);
    if (saveEmail) {
      localStorage.setItem("email", watchEmail);
    } else {
      localStorage.removeItem("email");
    }
  };

  return (
    <ThemeDefaultComponent>
      <Box
        padding={3}
        display={isDesktopScreen ? undefined : "flex"}
        justifyContent={isDesktopScreen ? undefined : "center"}
        sx={{ backgroundColor: "white" }}
      >
        <Box
          sx={{
            minHeight: "100vh",
            minWidth: "100vw",
            width: isTabletScreen ? undefined : "fit-content",
            position: "absolute",
            top: "50%",
            left: isTabletScreen ? "50%" : "25%",
            transform: "translate(-50%, -50%)",
            backgroundColor: "#FFF",
            display: "flex",
            justifyContent: "center",
            borderRadius: 1,
            paddingX: 2,
            paddingY: 2,
          }}
        >
          <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            paddingY={3}
            paddingX={isTabletScreen ? 2 : 4}
            sx={{
              backgroundColor: "#fff",
              borderRadius: "inherit",
            }}
          >
            <form
              style={{
                width: "100%",
                maxWidth: "500px",
                minWidth: "200px",
              }}
              onSubmit={handleSubmit(onSubmit)}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  marginBottom: "24px",
                }}
              >
                <img
                  src="/images/mtelogo-white.png"
                  width="300px"
                  height="150px"
                  style={{
                    objectFit: "contain",
                  }}
                />
              </Box>
              <Box
                sx={{
                  width: "fit-content",
                  marginTop: 3,
                  marginBottom: 6,
                }}
              >
                <Typography variant="h4" fontWeight="bold" color="#000">
                  Masuk
                </Typography>
              </Box>
              <Grid container spacing={1}>
                <Grid item xs={12}>
                  <Typography variant="body2">Email atau Username</Typography>
                  <Controller
                    name="email"
                    control={control}
                    render={({ field }) => (
                      <FormControl
                        fullWidth
                        variant="outlined"
                        error={Boolean(errors.email)}
                        sx={{
                          maxWidth: "500px",
                        }}
                      >
                        <OutlinedInput
                          id="email"
                          // type="email"
                          autoComplete="email"
                          autoFocus={isLaptopScreen}
                          placeholder="Contoh: budi1992@gmail.com / budi1992"
                          size="small"
                          {...field}
                        />
                        <FormHelperText>
                          {errors.email ? errors.email.message : " "}
                        </FormHelperText>
                      </FormControl>
                    )}
                    rules={{ required: "Email required" }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Typography variant="body2">Kata Sandi</Typography>
                  <Controller
                    name="password"
                    control={control}
                    render={({ field }) => (
                      <FormControl
                        fullWidth
                        variant="outlined"
                        error={Boolean(errors.password)}
                        sx={{
                          maxWidth: "500px",
                        }}
                      >
                        <OutlinedInput
                          id="password"
                          type={showPassword ? "text" : "password"}
                          autoComplete="password"
                          placeholder="Minimal 8 karakter"
                          endAdornment={
                            <InputAdornment position="end">
                              <IconButton
                                onClick={handleClickShowPassword}
                                edge="end"
                              >
                                {showPassword ? (
                                  <VisibilityOff />
                                ) : (
                                  <Visibility />
                                )}
                              </IconButton>
                            </InputAdornment>
                          }
                          size="small"
                          {...field}
                        />
                        <FormHelperText>
                          {errors.password ? errors.password.message : " "}
                        </FormHelperText>
                      </FormControl>
                    )}
                    rules={{
                      required: "Kata sandi required",
                    }}
                  />
                </Grid>
              </Grid>
              <Box display="flex" justifyContent="flex-end">
                <Link
                  component={RouterLink}
                  to="/lupa-kata-sandi"
                  variant="body2"
                  underline="hover"
                  sx={{
                    cursor: "pointer",
                  }}
                >
                  Lupa Kata Sandi?
                </Link>
              </Box>
              <Button
                type="submit"
                fullWidth
                size="large"
                variant="contained"
                color="secondary"
                sx={{ marginTop: 3, maxWidth: "500px" }}
              >
                Masuk
              </Button>
            </form>
          </Box>
        </Box>
        <LoadingOverlay open={isLoading} />
      </Box>
      {isTabletScreen === false ? (
        <Box
          sx={{
            minHeight: "100vh",
            minWidth: "50vw",
            position: "fixed",
            top: "49.9%",
            left: "75%",
            transform: "translate(-50%, -50%)",
            backgroundColor: "white",
            display: "flex",
            backgroundImage: `url(${cover})`,
            backgroundRepeat: "no-repeat",
            backgroundPosition: "top right",
            backgroundSize: "cover",
          }}
        />
      ) : null}
    </ThemeDefaultComponent>
  );
};

export default LoginPage;
